import { JS_SPACE, javaStrip } from '../javaText.ts';

/**
 * A die-roll range from a printed random table - `7`, `1-3`, `01-05`, `96-00` - and the
 * weight it stands for: a port of the desktop's `interchange.RollRange`.
 */
export class RollRange {
  constructor(
    readonly low: number,
    readonly high: number,
  ) {
    if (low < 0 || high < low) throw new RangeError(`Invalid roll range ${low}-${high}`);
  }

  /** A single roll or a range, or null; `00` is 100, and a range written high-to-low is refused. */
  static parse(text: string): RollRange | null {
    const match = new RegExp(`^(\\d{1,4})(?:${JS_SPACE}*(?:-|–|—|to)${JS_SPACE}*(\\d{1,4}))?$`).exec(javaStrip(text));
    if (!match) return null;
    const low = percentile(match[1]!);
    const high = match[2] === undefined ? low : percentile(match[2]);
    return high < low ? null : new RollRange(low, high);
  }

  size(): number {
    return this.high - this.low + 1;
  }

  /** `7`, or `1-3`; zero-padded to `width` digits when that's positive (`01-05`). */
  format(width: number): string {
    const pad = (value: number) => String(value).padStart(width, '0');
    return this.low === this.high ? pad(this.low) : `${pad(this.low)}-${pad(this.high)}`;
  }
}

const percentile = (digits: string) => (digits === '00' ? 100 : Number(digits));
